function overlay() {
  return {
    isOpen: false,
    handleEscape(event) {
      if (event.key !== "Escape") return;
      this.close();
    },
    init() {
      this.handleEscape = this.handleEscape.bind(this);
    },
    update() {
      this.loading = true;
    },
    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      window.ShopSuey.noScroll(true);
      document.addEventListener("keydown", this.handleEscape);
    },
    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      window.ShopSuey.noScroll(false);
      document.removeEventListener("keydown", this.handleEscape);
    },
    toggle(event) {
      if (event?.detail?.productType) {
        this.$el.setAttribute("data-product-type", event.detail.productType);
      }

      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },
    "close-all-modals.window": function () {
      this.close();
    }
  };
}

export default overlay;
